export enum ChatMessageTypeEnum {
  USERMESSAGE,
  PROVIDERMESSAGE,
  LOADER,
}
